import {createSlice} from '@reduxjs/toolkit';

const allItemKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'];

const initialState = {
    selectedItems: localStorage.getItem('selectedItems') ? JSON.parse(localStorage.getItem('selectedItems')) : allItemKeys
};

const liveItems = createSlice({
    name: 'liveItems',
    initialState,
    reducers: {
        toggleItemSelection: (state, action) => {
            const itemKey = action.payload;
            if (state.selectedItems.includes(itemKey)) {
                state.selectedItems = state.selectedItems.filter((key) => key !== itemKey);
            } else {
                state.selectedItems.push(itemKey);
            }
            localStorage.setItem('selectedItems', JSON.stringify(state.selectedItems));
        },
        selectAll: (state, action) => {
            state.selectedItems = action.payload;
            localStorage.setItem('selectedItems', JSON.stringify(state.selectedItems));
        },
        clearSelection: (state) => {
            state.selectedItems = [];
            localStorage.setItem('selectedItems', JSON.stringify(state.selectedItems));
        },
    },
});

export const {toggleItemSelection, selectAll, clearSelection} = liveItems.actions;
export default liveItems.reducer;
